"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const express_error_handlers_1 = require("@telus/express-error-handlers");
const userHelpers_1 = require("../../userHelpers");
/**
 * A function that takes in the reqOption object and sets the `Authorization` key to "REDACTED"
 * @param {object} reqOptions
 * @returns {object} with Authorization key changed to "REDACTED"
 */
const scrubOptions = (options) => {
    return { headers: Object.assign(Object.assign({}, options.headers), { Authorization: 'REDACTED' }) };
};
/**
 * A function that builds a different types of errors based on the status code passed in.
 * @param {number} statusCode
 * @param {string | object} statusText
 * @param {string} targetURL
 * @param {object} reqOptions
 * @param {object} resHeaders
 * @param {string} resBody
 * @returns {object} an error object to be thrown by fetchClient
 */
const buildError = (statusCode, statusText, targetURL, reqOptions, resHeaders = undefined, resBody = undefined) => {
    let error;
    const scrubbedUrl = (0, userHelpers_1.scrubData)(targetURL);
    const scrubbedStatusText = (statusText && (0, userHelpers_1.scrubData)(statusText)) || null;
    const scrubbedOptions = scrubOptions(reqOptions);
    const statusMessage = typeof scrubbedStatusText === 'object' ? JSON.stringify(scrubbedStatusText) : scrubbedStatusText;
    const errorMsg = `HTTP call to "${scrubbedUrl}" failed with status "${statusCode}", and with status message "${statusMessage}".
            ${JSON.stringify(scrubbedOptions)}`;
    switch (statusCode) {
        case 400:
            error = new express_error_handlers_1.errors.BadRequest(errorMsg);
            break;
        case 401:
            error = new express_error_handlers_1.errors.Unauthenticated(errorMsg);
            break;
        case 403:
            error = new express_error_handlers_1.errors.Forbidden(errorMsg);
            break;
        case 404:
            error = new express_error_handlers_1.errors.NotFound(errorMsg);
            break;
        default:
            error = new express_error_handlers_1.errors.Server(errorMsg);
            break;
    }
    error.statusCode = statusCode;
    error.statusText = scrubbedStatusText;
    error.targetURL = scrubbedUrl;
    if (resHeaders)
        error.resHeaders = resHeaders;
    if (resBody) {
        if (typeof resBody === 'object') {
            const scrubbedResBody = (0, userHelpers_1.scrubData)(resBody);
            error.resBody = scrubbedResBody;
        }
        if (typeof resBody === 'string') {
            try {
                const parsedResBody = JSON.parse(resBody);
                error.jsonBody = (0, userHelpers_1.scrubData)(parsedResBody);
            }
            catch (e) {
                error.jsonBody = undefined;
            }
        }
    }
    return error;
};
exports.default = buildError;
//# sourceMappingURL=buildError.js.map